import { useState, useEffect } from 'react'
import { usePushNotifications } from '../../hooks/usePushNotifications'
import s from './styles.module.scss'

export default function NotificationPrompt() {
  const { supported, subscribed, loading, requestPermission } = usePushNotifications()
  const [dismissed, setDismissed] = useState(false)

  // Check if user has dismissed this prompt before
  useEffect(() => {
    const dismissedBefore = localStorage.getItem('notificationPromptDismissed')
    if (dismissedBefore === 'true') {
      setDismissed(true)
    }
  }, [])

  // Don't show if:
  // - Not supported
  // - Already subscribed
  // - Loading
  // - User dismissed it
  if (!supported || subscribed || loading || dismissed) {
    return null
  }

  const handleEnable = async () => {
    const result = await requestPermission()
    if (result.success) {
      setDismissed(true)
    }
  }

  const handleDismiss = () => {
    setDismissed(true)
    localStorage.setItem('notificationPromptDismissed', 'true')
  }

  return (
    <div className={s.main}>
      <div className={s.content}>
        <div className={s.icon}>
          <span className="material-icons-outlined">notifications</span>
        </div>
        <div className={s.text}>
          <strong>Enable Notifications</strong>
          <p>Get real-time updates and never miss important messages</p>
        </div>
        <div className={s.actions}>
          <button className={s.enableButton} onClick={handleEnable}>
            Enable
          </button>
          <button className={s.dismissButton} onClick={handleDismiss}>
            <span className="material-icons-outlined">close</span>
          </button>
        </div>
      </div>
    </div>
  )
}

